import React, { useState, useContext, useEffect, useRef } from 'react';
import { jobPostingValidators, jobPostingDraftValidationKeys } from '../../../utils/validations';
import { JobPostingInput } from './JobPostingInput';
import { JobPostingBenefits } from './JobPostingBenefits';
import { JobPostingContext } from '../../../contexts/JobPostingContext';
import { JobPostingDropdown } from './JobPostingDropdown';
import { SuggestedLocationInput } from '../../common/SuggestedLocationInput/SuggestedLocationInput';
import PtpRichTextEditor from '../../common/PtpRichTextEditor/PtpRichTextEditor';

export const JobPostingFormElement = ({
  type, value, jpKey, label, options, errorText, required, placeholder
}) => {

  const { updateJobPostingField, savingJobPostingMode, editorModeActive } = useContext(JobPostingContext);
  const initialValue = useRef(value);
  const [dirty, setDirty] = useState(false);
  const [didError, setDidError] = useState(false);

  useEffect(function validateOnSave() {
    if (
      savingJobPostingMode === 'PUBLISH'
      || (savingJobPostingMode === 'DRAFT'
      && jobPostingDraftValidationKeys.includes(jpKey))) {
      setDirty(() => {
        setDidError(!validate());
        return false;
      });
    }
  }, [savingJobPostingMode]);

  function validate() {
    // if no validator, we simply return true
    // as field doesn't require validation
    if (!jobPostingValidators[jpKey]) {
      return true;
    }

    // check value in validation function
    return jobPostingValidators[jpKey]({
      [jpKey]: value
    });
  }

  function updateJobPostingAttr(newValue) {
    updateJobPostingField(jpKey, newValue);
  }

  function initFocus() {
    setDirty(true);
    setDidError(false);
  }

  const COMMON_PROPS = {
    label,
    type,
    dirty,
    onFocus: initFocus,
    value,
    jpKey,
    didError,
    errorText,
    required,
    validate,
    updateJobPostingAttr
  };

  switch (type) {
  case 'text':
    return (
      <JobPostingInput
        {...COMMON_PROPS}
      />
    );
  case 'textarea':
    return (
      <JobPostingInput
        {...COMMON_PROPS}
        type="textarea"
      />
    );
  case 'rte':
    return (
      <PtpRichTextEditor
        className="text-editor-edit"
        key={initialValue}
        callbackHTML={updateJobPostingAttr}
        jobDescriptionHTML={value}
        jobDescriptionDirty={dirty}
        setJobDescriptionDirty={setDirty}
        readOnly={!editorModeActive}
        testId={`job-posting-${editorModeActive ? 'editor' : 'static'}-${jpKey}`}
        errorText={errorText}
        placeholder={placeholder}
      />
    );
  case 'dropdown':
    return (
      <JobPostingDropdown
        options={options}
        isValid={!didError}
        {...COMMON_PROPS}
      />
    );
  case 'location':
    return (
      <SuggestedLocationInput
        {...COMMON_PROPS}
        locationText={value}
        locationTextError={errorText}
        validation={validate}
        setLocationTextError={didError}
        setLocationText={updateJobPostingAttr}
      />
    );
  case 'benefits':
    if (value) {
      return (
        <JobPostingBenefits
          {...COMMON_PROPS}
        />
      );
    }
    return <></>;
  default:
    return null;
  }
};
